import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HttpRequestService } from 'src/app/common/services/http-request.service';
import { Utils } from 'src/app/common/services/utils.service';

@Component({
  selector: 'app-weather',
  templateUrl: './weather.component.html',
  styleUrls: ['./weather.component.css']
})
export class WeatherComponent implements OnInit {

  weatherImages: any = [];
  radioform: FormGroup = new FormGroup({
    weatherList: new FormControl(null, Validators.required)
  });

  constructor(private utils: Utils,
    public ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private httpService: HttpRequestService) { }

  ngOnInit(): void {
    this.weatherImages = [
      {
        'weatherType': 'Good Weather(Low)',
        'imgUrl': 'assets/images/weather/good_weather.jpg',
        'weatherKey': 'GOODWEATHER',
        'risk':'LOW'
      },
      {
        'weatherType': 'Dust (Moderate)',
        'imgUrl': 'assets/images/weather/dust.jpg',
        'weatherKey': 'DUST',
        'risk':'MODERATE'
      },
      {
        'weatherType': 'Rain (High)',
        'imgUrl': 'assets/images/weather/rainny.jpg',
        'weatherKey': 'RAIN',
        'risk':'HIGH'
      },
      {
        'weatherType': 'Fog (High)',
        'imgUrl': 'assets/images/weather/foggy.jpg',
        'weatherKey': 'FOG',
        'risk':'HIGH'
      },
      {
        'weatherType': 'Night (High)',
        'imgUrl': 'assets/images/weather/twlight.jpg',
        'weatherKey': 'LOWLIGHT',
        'risk':'HIGH'
      }
      
    ];

    let existingWeather = this.config.data.weatherData;

    if(existingWeather != null){
       this.radioform.get('weatherList').setValue(existingWeather.weatherType);
    }
    
  }

  onImgClick(weatherKey){
    if(weatherKey != null){
      this.radioform.get('weatherList').setValue(weatherKey);
   }
  }

  onSubmit() {

    let selectedWeather = this.radioform.get('weatherList').value;

    let weather = this.weatherImages.find(weather => weather.weatherKey === selectedWeather);
    let riskPro = null;
    
    if(weather.risk=='HIGH'){
      riskPro = 'H';
    }
    else if(weather.risk=='MODERATE'){
      riskPro = 'M';
    }
    else if(weather.risk=='LOW'){
      riskPro = 'L';
    }
    else{
      riskPro = null;
    }

    let formValues: any = {
      'weatherType':selectedWeather,
      'riskProfile':riskPro
    }
    const requestData = this.utils.constructRequestData(formValues, 'WeatherMonitorController', 'saveWeatherProfiling');

    this.httpService.configRequestDataWithHeaders(requestData, 'post', '').subscribe(
      (response: any) => {
        if (response && response.strFailureMsg == null) {
          this.ref.close();
           }
           else{
            return;
           }
      });


  }

}
